/* Galerie Signature — chování obchodu.
   Vše je progresivní vylepšení: bez JavaScriptu zůstane stránka nakupovatelná. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Filtr děl na úvodní stránce
     --------------------------------------------------------------- */
  (function filters() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-filter]'));
    var cards = Array.prototype.slice.call(document.querySelectorAll('.art-card'));
    if (!buttons.length || !cards.length) return;

    function apply(value) {
      buttons.forEach(function (b) {
        var on = b.dataset.filter === value;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      cards.forEach(function (c) {
        var cats = (c.dataset.category || '').split(' ').filter(Boolean);
        c.hidden = value !== 'all' && cats.indexOf(value) === -1;
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.dataset.filter);
      });
    });
  })();

  /* ---------------------------------------------------------------
     Uvodni scena — levitujici dila.
     Paralaxa jde pres CSS promenne --mx/--my na cele scene, takze pohyb
     mysi nevyvolava prekresleni obsahu. Kdyz si navstevnik prohlizi jedno
     dilo, ostatni jen ustoupi — nic se nepreklada pres sousedy.
     --------------------------------------------------------------- */
  (function heroStage() {
    var stage = document.querySelector('[data-hero-stage]');
    if (!stage) return;

    var tiles = Array.prototype.slice.call(stage.querySelectorAll('.floating-art'));
    if (!tiles.length) return;

    var wide = window.matchMedia('(min-width: 981px)');

    function focus(tile) {
      tiles.forEach(function (t) {
        if (t === tile) {
          t.setAttribute('data-active', 'true');
        } else {
          t.removeAttribute('data-active');
        }
      });
      stage.setAttribute('data-focus', tile ? 'true' : 'false');
    }

    // Zhasnutí zvýraznění se odkládá o chvilku: při přejezdu z fotky na sousední
    // fotku jinak celá scéna na jeden snímek prosvítila a zase ztmavla, což
    // při rychlém pohybu myši vypadalo jako blikání (2026-09-13).
    var clearTimer = 0;
    function scheduleClear() {
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () { focus(null); }, 160);
    }
    function clearNow() {
      clearTimeout(clearTimer);
      focus(null);
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('pointerenter', function () {
        clearTimeout(clearTimer);
        if (wide.matches) focus(tile);
      });
      tile.addEventListener('focus', function () {
        if (wide.matches) focus(tile);
      });
      tile.addEventListener('blur', scheduleClear);
      // Zvýraznění se dřív rušilo až při opuštění celé scény. Box s nahráním
      // fotky je ale uvnitř scény, takže při přejezdu na tlačítko zůstala
      // poslední dlaždice zvětšená a zbytek ztlumený (2026-09-13).
      tile.addEventListener('pointerleave', scheduleClear);
    });

    var uploadBox = stage.querySelector('.ai-recommend--hero');
    if (uploadBox) {
      uploadBox.addEventListener('pointerenter', clearNow);
    }

    if (reduced || !window.matchMedia('(pointer:fine)').matches) return;

    var raf = 0;
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !wide.matches) return;
      var r = stage.getBoundingClientRect();
      var mx = (e.clientX - r.left) / r.width - 0.5;
      var my = (e.clientY - r.top) / r.height - 0.5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        stage.style.setProperty('--mx', (mx * 2).toFixed(3));
        stage.style.setProperty('--my', (my * 2).toFixed(3));
      });
    });

    stage.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      stage.style.setProperty('--mx', '0');
      stage.style.setProperty('--my', '0');
      clearNow();
    });
  })();

  /* ---------------------------------------------------------------
     Odhalování sekcí při scrollu
     --------------------------------------------------------------- */
  (function reveal() {
    if (reduced) return;
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in-view');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    document
      .querySelectorAll('.section-heading, .collection, .room-section, .story-bottom')
      .forEach(function (el) {
        el.classList.add('reveal-ready');
        obs.observe(el);
      });
  })();

  /* ---------------------------------------------------------------
     Výběr provedení na stránce díla
     Řádky dlaždic (druh tisku / velikost / rám / …), jeden řádek na
     každou product option. Data o variantách jsou vložená jako JSON
     přímo v šabloně (data-variant-data), takže není potřeba AJAX dotaz.
     Řádky jsou navzájem NEZÁVISLÉ — klik v jednom řádku nikdy nezmění
     výběr v jiném řádku. Pokud zvolená kombinace neexistuje jako
     varianta, tlačítko "Přidat do košíku" se jen deaktivuje; volby
     samy se nepřehazují.
     --------------------------------------------------------------- */
  (function variantPicker() {
    var picker = document.querySelector('[data-option-picker]');
    var dataEl = document.querySelector('[data-variant-data]');
    if (!picker || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!variants || !variants.length) return;

    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var button = document.getElementById('add-to-cart');
    var label = document.querySelector('[data-add-label]');
    var variantTitle = document.querySelector('[data-variant-title]');
    var rows = Array.prototype.slice.call(picker.querySelectorAll('[data-option-row]'));

    function optionsOf(variant) {
      return [variant.option1, variant.option2, variant.option3].filter(function (v) {
        return v !== null && v !== undefined;
      });
    }

    function currentSelection() {
      return rows.map(function (row) {
        var active = row.querySelector('.option-pill.selected');
        return active ? active.dataset.optionValue : null;
      });
    }

    function findExact(selection) {
      return variants.filter(function (variant) {
        var opts = optionsOf(variant);
        return opts.every(function (val, i) {
          return selection[i] == null || val === selection[i];
        });
      })[0];
    }

    function markUnavailable() {
      if (idInput) idInput.value = '';
      if (button) {
        button.disabled = true;
        if (label && button.dataset.labelUnavailable) {
          label.textContent = button.dataset.labelUnavailable;
        }
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        markUnavailable();
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = variant.price > 0 ? formatMoney(variant.price) : priceEl.dataset.onRequest || priceEl.textContent;
      }
      if (variantTitle) variantTitle.textContent = variant.title;
      if (button) {
        button.disabled = !variant.available;
        if (label && button.dataset.labelAvailable && button.dataset.labelUnavailable) {
          label.textContent = variant.available ? button.dataset.labelAvailable : button.dataset.labelUnavailable;
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    function formatMoney(cents) {
      // Poznámka: ceny jsou zatím u všech děl "Cena na dotaz" (0), takže
      // tahle větev se v praxi nevyvolává; jde jen o bezpečný fallback.
      return (cents / 100).toFixed(2).replace('.', ',') + ' Kč';
    }

    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('.option-pill');
      if (!pill) return;
      var row = pill.closest('[data-option-row]');

      // Přepnout dlaždice jen v řádku, kde se kliklo — ostatní řádky
      // se nedotýkají.
      Array.prototype.slice.call(row.querySelectorAll('.option-pill')).forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('selected', on);
        p.setAttribute('aria-pressed', String(on));
      });

      applyVariant(findExact(currentSelection()));
    });

    applyVariant(findExact(currentSelection()));
  })();

  /* ---------------------------------------------------------------
     Zvětšení obrazu
     --------------------------------------------------------------- */
  (function zoom() {
    var dialog = document.getElementById('zoom-dialog');
    var image = document.getElementById('zoom-image');
    if (!dialog || !image || typeof dialog.showModal !== 'function') return;

    document.querySelectorAll('[data-zoom-src]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        image.src = trigger.dataset.zoomSrc;
        image.alt = trigger.dataset.zoomAlt || '';
        dialog.showModal();
      });
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    var close = dialog.querySelector('[data-zoom-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { image.removeAttribute('src'); });
  })();

  /* ---------------------------------------------------------------
     Košík — změna počtu odešle formulář, aby nebylo nutné klikat na Aktualizovat
     --------------------------------------------------------------- */
  (function cart() {
    var inputs = document.querySelectorAll('[data-cart-qty]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (!form) return;
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'update';
        hidden.value = '';
        form.appendChild(hidden);
        form.submit();
      });
    });
  })();

  /* ---------------------------------------------------------------
     Přepínač jazyka — skutečné vlaječky (obrázky), ne emoji.
     Nativní <select> je funkční zdroj pravdy (submit formuláře, ovládání
     klávesnicí, čtečky obrazovky); nad ním postavíme jen vizuální overlay
     s vlaječkami, protože do <option> nejde vložit <img>.
     --------------------------------------------------------------- */
  (function localeSwitch() {
    var selects = document.querySelectorAll('[data-locale-switch]');
    if (!selects.length) return;

    function flagUrl(code, size) {
      return 'https://flagcdn.com/' + size + '/' + code + '.png';
    }

    Array.prototype.forEach.call(selects, function (select) {
      // data-locale-inline = seznam s vlaječkami stále rozbalený (mobilní menu)
      var inline = select.hasAttribute('data-locale-inline');
      var w = inline ? 24 : 20;
      var h = inline ? 18 : 15;

      var wrap = document.createElement('div');
      wrap.className = 'lang-switch' + (inline ? ' lang-switch--inline' : '');

      var list = document.createElement('ul');
      list.className = 'lang-switch-list';
      list.setAttribute('role', 'listbox');
      list.hidden = !inline;

      function optionRow(opt) {
        // Přepínač měny nemá vlaječky, jen kód a symbol — obrázek je proto nepovinný.
        // loading="lazy" + decoding="async" (2026-09-14): vlaječky se tažou z cizí
        // domény flagcdn.com a je jich 23; takhle si na ně prohlížeč počká, až
        // budou opravdu vidět, a nebrzdí jimi načítání stránky na mobilu.
        var flag = opt.dataset.flag;
        var img = flag
          ? '<img src="' + flagUrl(flag, w + 'x' + h) + '" alt="" width="' + w + '" height="' + h + '" loading="lazy" decoding="async">'
          : '';
        return img + '<span>' + opt.textContent.trim() + '</span>';
      }

      Array.prototype.forEach.call(select.options, function (opt) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.value = opt.value;
        li.innerHTML = optionRow(opt);
        if (opt.selected) li.setAttribute('aria-selected', 'true');
        li.addEventListener('click', function () {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        list.appendChild(li);
      });

      select.parentNode.insertBefore(wrap, select);
      wrap.appendChild(select);

      if (!inline) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'lang-switch-button';
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        var current = select.options[select.selectedIndex];
        button.innerHTML = optionRow(current) + '<b aria-hidden="true">▾</b>';

        button.addEventListener('click', function () {
          var open = !list.hidden;
          list.hidden = open;
          button.setAttribute('aria-expanded', String(!open));
        });

        document.addEventListener('click', function (e) {
          if (!wrap.contains(e.target)) {
            list.hidden = true;
            button.setAttribute('aria-expanded', 'false');
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            list.hidden = true;
            button.setAttribute('aria-expanded', 'false');
          }
        });

        wrap.appendChild(button);
      }

      wrap.appendChild(list);
      select.classList.add('visually-hidden');
    });
  })();
})();
